import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  state: {
    reportFormUngulate: null
  },
  mutations: {
    setReportFormUngulate (state, item) {
      state.reportFormUngulate = item
    }
  },
  actions: {
    fetchEntityConstantData ({ commit }) {
      return axios
        .get(`${i18n.locale}/api/public/entityConstant`)
        .then(({ data }) => {
          commit('setReportFormUngulate', data.reportFormUngulate)
          return Promise.resolve(data)
        })
    }
  }
}
